import { ReactNode, useState } from 'react';
import { Space } from 'antd';

import Icon from '../../../../common/components/Icon/Icon';

import styles from './TransportAccordion.module.scss';

interface Props {
  title: ReactNode;
  children: ReactNode;
  theme?: 'light' | 'dark';
}

export const TransportAccordion = (props: Props) => {
  const { title, children, theme } = props;
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <Space
        className={styles.title}
        onClick={() => setIsOpen(!isOpen)}
      >
        {title}
        <Icon name={isOpen ? 'arrow-up-s' : 'arrow-down-s'} theme={theme} />
      </Space>

      <div className={isOpen ? styles.showChildren : styles.hideChildren}>{children}</div>
    </div>
  );
};
